// extracted by mini-css-extract-plugin
export default {"cancelAlert":"CancelButton_cancelAlert__jZwns"};